import { render, staticRenderFns } from "./DriversDeliveryDestinations.vue?vue&type=template&id=fadc2ea2&scoped=true&"
import script from "./DriversDeliveryDestinations.vue?vue&type=script&lang=js&"
export * from "./DriversDeliveryDestinations.vue?vue&type=script&lang=js&"
import style0 from "./DriversDeliveryDestinations.vue?vue&type=style&index=0&id=fadc2ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadc2ea2",
  null
  
)

export default component.exports